import { render, staticRenderFns } from "./fccAreaEspecifica.vue?vue&type=template&id=3ad6b374"
import script from "./fccAreaEspecifica.vue?vue&type=script&lang=js"
export * from "./fccAreaEspecifica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports